// src/components/platform/PlatformPillarCard.tsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { renderIcon } from '@dopomogai/utils';
import { Badge, IconName } from '@dopomogai/ui';

interface PillarData {
  icon: IconName;
  titleKey: string;
  textKey: string;
  sprintDay: number;
}

interface PlatformPillarCardProps {
  pillar: PillarData;
  isReversed?: boolean;
}

export const PlatformPillarCard: React.FC<PlatformPillarCardProps> = ({ pillar, isReversed }) => {
  const { t } = useTranslation('the-platform');
  
  return (
    <motion.div 
      initial={{ opacity: 0, x: isReversed ? 50 : -50 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className="bg-white p-8 rounded-xl border-2 border-black shadow-[6px_6px_0_0_black] space-y-4"
    >
      <div className="flex justify-between items-start">
        <span className="p-3 bg-slate-100 border-2 border-black rounded-lg">{renderIcon(pillar.icon)}</span>
        <Badge text={`Coming Soon - Day ${pillar.sprintDay}`} accentColor="purple" />
      </div>
      <h3 className="text-2xl font-bold text-gray-900 !mt-6">{t(pillar.titleKey)}</h3>
      <p className="text-slate-600">{t(pillar.textKey)}</p>
    </motion.div>
  );
};